import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-true-answers",
  templateUrl: "./true-answers.component.html",
  styleUrls: ["./true-answers.component.css"],
})
export class TrueAnswersComponent implements OnInit {
  questions = [];
  mat_id;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private _location: Location
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.mat_id = params["mat"];
    });

    this.http
      .get(`${environment.apiUrl}/quizz/get-quizzes-by-mat-id/${this.mat_id}`)
      .subscribe((data) => (this.questions = data["data"][0]["questions"]));
  }

  back() {
    this._location.back();
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    return this.http
      .post(`${environment.apiUrl}/auth/logout`, {})
      .subscribe(
        (data) => (window.location.href = "https://sinnara-app.com/log-in.html")
      );
  }
}
